<template>
	<div>
		<div v-if="loading">
			<div class="success--text text-h4 text-center">
				در حال دریافت اطلاعات...
			</div>
		</div>
		<div v-else>
			<div v-if="!items.length">
				<h3 class="text-center red--text">طرف حسابی برای این نوع وام ثبت نشده است</h3>
				<div class="text-center mt-5">
					<v-btn class="mx-auto" color="secondary" dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن سهم طرف حساب
					</v-btn>
				</div>
			</div>
			<div v-else>
				<v-card v-for="(item, index) in items" :key="item.id + index" class="mb-3 pa-3" elevation="0"
					style="border: 1px solid #dca6e5">
					<v-row class="d-flex">
						<v-col cols="12" md="7" class="py-0 my-0">
							<div class="text-h4">{{ item.contact.fullName }}</div>
							<div class="text-h6 grey--text"><span>{{ item.contact.businessName }}</span></div>
						</v-col>
						<v-col cols="12" md="3" class="py-0 my-0">
							<v-text-field maxlength="6" v-model="item.share" label="درصد سهم" :error-messages="errorMessages"
								:rules="[(val) => val >= 0 || 'درصد سهم طرف حساب را وارد کنید', (val) => val <= 100 || 'درصد سهم طرف حساب نمی تواند بیشتر از 100 باشد']"
								required />
						</v-col>
						<v-col cols="1" md="2" class="my-0 py-0 d-flex align-center">
							<v-btn :loading="submitLoading" @click="update(item, index)" class="ms-2" color="success" x-small icon dark
								title="ذخیره">
								<v-icon dark>
									mdi-check
								</v-icon>
							</v-btn>
							<v-btn @click="remove(item, index)" :loading="loading" class="" color="red" x-small icon dark title="حذف">
								<v-icon>
									mdi-trash-can-outline
								</v-icon>
							</v-btn>
						</v-col>
					</v-row>
				</v-card>
				<div class="text-center mt-5">
					<v-btn class="mx-auto" color="secondary" dark @click="add">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن سهم طرف حساب
					</v-btn>
				</div>
			</div>
		</div>
		<v-dialog v-model="dialog" scrollable persistent max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline">مدیریت طرف حساب ها</span>
					<v-spacer />
					<v-btn @click="dialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<Contacts @select="addSelection" v-if="dialog" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>
		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'

	export default {
		name: 'LoanContacts',
		props: {
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			Contacts: () => import('@/components/forms/Contacts.vue'),
		},
		data() {
			return {
				errorMessages: '',
				items: [],
				localData: {},
				submitLoading: false,
				loading: false,
				dialog: false
			}
		},
		computed: {

		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('admin/LoanContact/ListByLoanId/' + this.data.id, null)
					.then(
						response => {
							this.items = response.map(x => {
								x.editMode = false
								return x
							})
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			async remove(item, index) {
				if (!item) {
					return
				}

				if (item.id == emptyId) {
					this.items.splice(index, 1)
					return
				}

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('admin/LoanContact/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.items.splice(index, 1)
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			add() {
				this.dialog = true
			},
			update(item, index) {
				const sum = this.items.reduce((accumulator, object) => {
					return accumulator + Number(object.share)
				}, 0)
				if (sum > 100) {
					toast.error('مجموع درصد ها نباید بیشتر از 100 درصد باشد.')
					return
				}
				api.post('admin/LoanContact/edit', item)
					.then(response => {
						toast.success(`سهم ${item.contact.fullName} با موفقیت ثبت شد.`)
					})
					.catch(err => {
						toast.error(err.message)
					})
			},
			async addSelection(items) {
				this.dialog = false
				let itemsToAdd = []
				if (items?.length > 0) {
					itemsToAdd = items.filter(x => !this.items.some(i => i.contact.id === x.id))
				}

				if (!itemsToAdd.length)
					return

				this.loading = true
				for (let index = 0; index < itemsToAdd.length; index++) {
					let item = itemsToAdd[index]
					let data = {
						contact: { id: item.id, fullName: item.fullName, businessName: item.businessName, phone: item.phone, address: item.address },
						loan: { id: this.data.id },
					}
					await api.post('admin/LoanContact/create', data)
						.then(response => {
							toast.success(`آیتم ${item.fullName} با موفقیت اضافه شد.`)
							if (item.id === emptyId) {
								item.id = response
							}
						})
						.catch(err => {
							toast.error(err.message)
						})
				}
				this.loadData()
			}
		},
	}
</script>
<style></style>
